import { PropsWithChildren } from 'react'

export default function Label(props: PropsWithChildren) {
	return <div className="label">{props.children}</div>
}
